import React from 'react';
import TagPill from './TagPill';

/**
 * SelectedTags Component
 * 
 * Displays the currently selected tags with primary tag row and other tags.
 */
const SelectedTags = ({
  tagObjects,
  taskId,
  onRemoveTag,
  onSetPrimary,
}) => {
  if (tagObjects.length === 0) return null;

  const primaryTag = tagObjects[0];
  const otherTags = tagObjects.slice(1);

  return (
    <div className="tags-picker__selected">
      {/* Primary tag row */}
      {primaryTag && (
        <div className="tags-picker__primary-row">
          <span className="tags-picker__primary-label">Primary Tag:</span>
          <TagPill
            tag={primaryTag}
            isPrimary
            onRemove={onRemoveTag}
            title="Primary tag — used for table grouping"
          />
        </div>
      )}
      
      {/* Other tags */}
      {otherTags.length > 0 && (
        <>
          <div className="tags-picker__other-label">Click to set as primary:</div>
          <div className="tags-picker__pills">
            {otherTags.map((tag) => (
              <TagPill
                key={tag.name}
                tag={tag}
                onClick={(e) => {
                  e.stopPropagation();
                  onSetPrimary?.(tag.name);
                }}
                onRemove={onRemoveTag}
                title="Click to set as primary tag"
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default SelectedTags;

